__turbopack_context__.v({
  "button": "dropdown-navigation-module-scss-module__Fm3PmW__button",
  "container": "dropdown-navigation-module-scss-module__Fm3PmW__container",
  "link": "dropdown-navigation-module-scss-module__Fm3PmW__link",
  "links": "dropdown-navigation-module-scss-module__Fm3PmW__links",
  "up": "dropdown-navigation-module-scss-module__Fm3PmW__up",
});
